import { inject, provideAppInitializer } from '@angular/core';
import { ConfigService } from '@rxap/config';
import { isUploadEnabled } from '../is-upload-enabled';
import { requestApiConnectionStore } from '../stores/request-api-connection.store';
import { RequestApiConnectionService } from './request-api-connection.service';

/**
 * Restores the persisted active request api connection at bootstrap so its
 * base url override survives a reload. Restricted to upload mode —
 * fixed-source deployments must never have their `iirds` server redirected by
 * a stale localStorage value.
 */
export function provideRequestApi() {
  return [
    provideAppInitializer(() => {
      const config = inject(ConfigService);
      if (!isUploadEnabled(config)) {
        return;
      }
      const store = inject(requestApiConnectionStore);
      const connectionService = inject(RequestApiConnectionService);
      const activeId = store.activeId();
      if (!activeId) {
        return;
      }
      // Restore in the background — bootstrap must not block on IndexedDB.
      void store
        .load()
        .then(() => {
          if (store.activeConnection()) {
            return connectionService.activate(activeId);
          }
          // stale persisted id (connection removed or config changed)
          store.setActive(null);
          return undefined;
        })
        .catch((error) => {
          console.error(
            'Failed to restore the active request api connection',
            error,
          );
        });
    }),
  ];
}
